import './App.css';
import ClockCurrentDateAndTime from './ClockCurrentDateAndTime';
import AnalogClockCurrentTime from './AnalogClockCurrentTime';
import Stopwatch from './Stopwatch';
import WorldClock from './WorldClock';
import Alarm from './Alarm';
import Timer from './Timer';
import styled from 'styled-components';

const StyledText = styled.h1`
  color: transparent;
  -webkit-text-stroke: 1px black;
  background: linear-gradient(135deg, #14ffe9, #ffeb3b, #ff00e0);
  -webkit-background-clip: text;
`;

function App() {

  return (
    <div className="App">
      <center>
        <br />
        <StyledText className='btnBorder' style={{fontSize:'35px'}}>The Clock Application</StyledText>
        <div className='features'>
          
          <div className='violet-border'>
            <StyledText>Stopwatch</StyledText>
            <Stopwatch/>
          </div>

          <div className='violet-border'>
            <StyledText>Analog Clock</StyledText> <br />
            <AnalogClockCurrentTime/> <br />
            <StyledText>Digial Clock</StyledText>
            <ClockCurrentDateAndTime/> <br />
          </div>

          <div>
            <div className='violet-border'>
              <StyledText>Countdown Timer</StyledText> <br />
              <Timer/>
            </div>
            <div className='violet-border'>
              <StyledText>Alarm</StyledText>
              <Alarm title='Alarm'/>
            </div>
          </div>

        </div>
        
        <div className='violet-border'>
          <StyledText>World Clock</StyledText><br />
          <WorldClock/>
        </div>
        
      </center>
    </div>
  );
}

export default App;
